// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBHYrujqt2HlhnyYlrMivS6NePjSxlbAK0",
  authDomain: "goldfinder-5e059.firebaseapp.com",
  projectId: "goldfinder-5e059",
  storageBucket: "goldfinder-5e059.firebasestorage.app",
  messagingSenderId: "1023261735216",
  appId: "1:1023261735216:web:3f6007c01c3c2f148df0f5",
  measurementId: "G-2XVRE7T5JZ"
};


// Initialize Firebase

const app = initializeApp(firebaseConfig);

// Only initialize analytics in production to avoid cookie domain errors in development
const analytics = process.env.NODE_ENV === 'production' ? getAnalytics(app) : null;
const auth = getAuth(app);
const db = getFirestore(app)

export {app, auth, db};